
import React from 'react';
import { User, Clock, Target, Briefcase } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const CareerTab = () => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center">
        <User className="mr-2 h-5 w-5" /> Career Progression
      </h3>
      <p>
        Your career follows a structured progression path through several levels. Each level
        requires meeting specific experience points and time requirements.
      </p>
      
      <div className="border rounded-md p-4 bg-muted/20 space-y-3">
        <h4 className="font-medium">Career Levels</h4>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium flex items-center">
              <Briefcase className="h-4 w-4 mr-2 text-bitcoin-primary" />
              Junior
            </h5>
            <p>Starting level - focus on learning fundamental skills and improving basic KPIs</p>
            <div className="mt-2 text-xs text-muted-foreground">
              <div className="flex justify-between">
                <span>Required XP: 0</span>
                <span>Required Years: 0</span>
              </div>
            </div>
          </div>
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium flex items-center">
              <Briefcase className="h-4 w-4 mr-2 text-bitcoin-primary" />
              Mid-Level
            </h5>
            <p>Requires ~150 XP and 3 years - more challenging decisions with greater impact</p>
            <div className="mt-2 text-xs text-muted-foreground">
              <div className="flex justify-between">
                <span>Required XP: 150</span>
                <span>Required Years: 3</span>
              </div>
            </div>
          </div>
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium flex items-center">
              <Briefcase className="h-4 w-4 mr-2 text-bitcoin-primary" />
              Senior
            </h5>
            <p>Requires ~350 XP and 6 years - strategic decisions that affect multiple KPIs</p>
            <div className="mt-2 text-xs text-muted-foreground">
              <div className="flex justify-between">
                <span>Required XP: 350</span>
                <span>Required Years: 6</span>
              </div>
            </div>
          </div>
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium flex items-center">
              <Briefcase className="h-4 w-4 mr-2 text-bitcoin-primary" />
              Leader
            </h5>
            <p>Requires ~700 XP and 10 years - high-level decision making with industry-wide impact</p>
            <div className="mt-2 text-xs text-muted-foreground">
              <div className="flex justify-between">
                <span>Required XP: 700</span>
                <span>Required Years: 10</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="border-l-4 border-primary p-4 bg-primary/5">
        <h4 className="font-medium flex items-center">
          <Clock className="mr-2 h-4 w-4 text-primary" /> Promotion Requirements
        </h4>
        <p className="text-sm">
          To advance to the next level, you need to meet BOTH the experience points
          requirement AND the years of service requirement. Focus on completing
          challenging decisions to earn experience faster!
        </p>
      </div>
      
      <div className="p-4 border rounded-md bg-muted/10">
        <h4 className="font-medium flex items-center mb-2">
          <Target className="mr-2 h-4 w-4 text-web3-blue" /> Career Specializations
        </h4>
        <p className="text-sm mb-3">
          As you progress, you'll unlock career specialization paths that provide unique bonuses:
        </p>
        <div className="grid grid-cols-2 gap-3 text-xs">
          <div className="p-2 border rounded">
            <span className="font-medium">Technical Path</span>: Improves efficiency and uptime
          </div>
          <div className="p-2 border rounded">
            <span className="font-medium">Management Path</span>: Boosts profit margins and team performance
          </div>
          <div className="p-2 border rounded">
            <span className="font-medium">Entrepreneurial Path</span>: Enhanced profit and innovation
          </div>
          <div className="p-2 border rounded">
            <span className="font-medium">Research Path</span>: Improved energy costs and efficiency
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerTab;
